import React from "react";
import { useExtensionObjects } from "../ExtensionProvider";
const registerFooter = (_instanceGroup, id, component, props) => {
    return { id, component, props };
};
/**
 * Footer on the main window. Can be extended
 */
export const MainFooter = ({ slim }) => {
    const footers = useExtensionObjects(registerFooter);
    const renderFooter = (footer) => {
        const props = footer.props !== undefined ? footer.props() : {};
        return React.createElement(footer.component, { key: footer.id, slim: slim, ...props });
    };
    return React.createElement("div", { id: "main-footer" }, footers.map(renderFooter));
};
export default MainFooter;
